import { EntityState, createEntityAdapter } from '@ngrx/entity';
import { AirportsInfo } from '../../../dtos/response/airports-info-response/airports-info';
import { RootState } from '../../../state/state';

/**
 * The string name of the airports info service 'slice' of state
 */
export const airportsInfoServiceFeatureKey = 'airportsInfoService';

/**
 * Extension pattern used to prevent breaking lazy loading while maintaining a global state model
 */
export interface State extends RootState {
  airportsInfoService: AirportsInfoServiceState;
}

export interface AirportsInfoServiceState {
  airports: AirportsInfoEntity;
  loading: boolean;
  error: string | null;
}

export interface AirportsInfoEntityModel {
  airports: AirportsInfo[];
  id: string;
}

export interface AirportsInfoEntity extends EntityState<AirportsInfoEntityModel> {}

export const airportsInfoAdapter = createEntityAdapter<AirportsInfoEntityModel>({
  selectId: (airportsInfo) => airportsInfo?.id ?? '',
});

/**
 * Initial state of the airports info service slice of state, used when airports info service state is
 * bootstrapped via the reducer in an app module also used when state is reset
 */
export const initialAirportsInfoServiceState: AirportsInfoServiceState = {
  airports: airportsInfoAdapter.getInitialState(),
  loading: false,
  error: null,
};
